/* import __COLOCATED_TEMPLATE__ from './lsg-profile-link.hbs'; */
import { computed } from '@ember/object';
import Component from '@ember/component';

export default Component.extend({
  /** @inheritDoc */
  tagName: '',

  /** @param {'user'|'company'|null} type */
  type: null,

  /** @param {User|Company|null} model */
  model: null,

  /** @param {String} class */
  class: '',

  /** @param {Function} onClick */
  onProfileLinkClick: () => {},

  /** @type {String} Link to the profile. */
  href: computed('type', 'model.slug', function () {
    const type = this.get('type');
    const slug = this.get('model.slug');

    switch (type) {
      case 'user':
        return `/${slug}`;
      case 'company':
        return `/company/${slug}`;
      default:
        return '';
    }
  }),

  actions: {
    /**
     * Handle when the user clicks on this profile link.
     *
     * @param {MouseEvent} event
     */
    handleProfileLinkClick(event) {
      event.stopPropagation();
      event.preventDefault();

      /**
       * Nested somewhere within this component, there may be a Materialize Dropdown element (for
       * example, as part of `lsg/dropdowns/lsg-circle-button-dropdown`). The Materialize library
       * doesn't allow us to prevent click events from bubbling up, so to stop those clicks from
       * triggering the profile overlay here, we have to return early if we detect that the clicked
       * element has a Materialize Dropdown associated with it.
       */
      if (event.target.M_Dropdown) return;

      this.get('onProfileLinkClick')();
    },
  },
});
